var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoNsoft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 290,
    viewBox: "0 0 226 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.45 0.72998H10.97C5.44715 0.72998 0.970001 5.20713 0.970001 10.73V278.54C0.970001 284.063 5.44715 288.54 10.97 288.54H215.45C220.973 288.54 225.45 284.063 225.45 278.54V10.73C225.45 5.20713 220.973 0.72998 215.45 0.72998Z",
    fill: "url(#paint0_linear_1_16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.45 0.72998H10.97C5.44715 0.72998 0.970001 5.20713 0.970001 10.73V278.54C0.970001 284.063 5.44715 288.54 10.97 288.54H215.45C220.973 288.54 225.45 284.063 225.45 278.54V10.73C225.45 5.20713 220.973 0.72998 215.45 0.72998Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.52 187.35C146.845 187.35 173.86 160.335 173.86 127.01C173.86 93.6851 146.845 66.67 113.52 66.67C80.1951 66.67 53.18 93.6851 53.18 127.01C53.18 160.335 80.1951 187.35 113.52 187.35Z",
    fill: "#7FD2FF",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 288.65C20.66 288.65 36.61 213 63.81 179.22C63.81 179.22 109.14 220.49 161.98 179.22C161.98 179.22 186.36 219.22 202.93 288.34",
    fill: "#7FD2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 288.65C20.66 288.65 36.61 213 63.81 179.22C63.81 179.22 109.14 220.49 161.98 179.22C161.98 179.22 186.36 219.22 202.93 288.34",
    stroke: "black",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16",
    x1: 111.41,
    y1: 39.19,
    x2: 115.23,
    y2: 263.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7FD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#76CEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5CC4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#33B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#009EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#219AE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNsoft);
export default __webpack_public_path__ + "static/media/ICONsoft.60b4cf9812eedf8a865cd238828cb2aa.svg";
export { ForwardRef as ReactComponent };